import common from './resources/common/common.es';

export default { common };
